<template>
  <!-- 质检单管理 -->
  <div class="main-container">
    <div class="search-box btn3" :class="{ close: !searchMore }">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">产品</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">出单机构/团队</span>
        <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
      </div>
      <div class="input-item">
        <span class="label">出单业务员</span>
        <Input v-model="searchParams.salesmanName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">犹豫期截止日</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          v-model="searchParams.date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">质检状态</span>
        <Select v-model="searchParams.confirmRightStatusIn" :transfer="true" clearable multiple>
          <Option value="0">待单录</Option>
          <Option value="1">待质检</Option>
          <Option value="2">质检成功</Option>
          <Option value="-1">质检失败</Option>
        </Select>
      </div>

      <div class="input-item" v-if="$units.isOkBao() || $units.isRYBB()">
        <span class="label">个险销售支持</span>
        <Select v-model="searchParams.salesSupportId" clearable filterable>
          <Option v-for="(item, i) in salesSupportList" :key="i" :value="item.id" :label="item.name"></Option>
        </Select>
      </div>
      <div class="input-item select-two">
        <Select v-model="searchParams.userType" :transfer="true">
          <Option value="1">投保人</Option>
          <Option value="2">被保险人</Option>
        </Select>
        <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up" /></Button>
        <Button type="primary" ghost v-else @click="searchMore = true">展开<Icon type="ios-arrow-down" /></Button>
      </div>
    </div>
    <div class="tools-box right">
      <Button type="primary" ghost @click="daochu()">导出</Button>
      <Button type="primary" @click="$refs.addForm.open()">新增</Button>
    </div>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" v-if="tableData.length">
        <template slot-scope="{ row }" slot="sellTypeSlot">
          <div class="sellTypeColumn" v-if="row.sellTypes">
            <Tag color="blue" v-if="row.sellTypes.includes('1')">网销</Tag>
            <Tag color="blue" v-if="row.sellTypes.includes('2')">电销</Tag>
            <Tag color="blue" v-if="row.sellTypes.includes('3')">经代</Tag>
          </div>
          <div v-else>-</div>
        </template>
        <!-- 出单团队 -->
        <template slot-scope="{ row }" slot="confirmRightStatusIn">
          <span v-if="row.confirmRightStatus === 0 && row.confirmRightMode == 2">待人工回访</span>
          <span v-else-if="row.confirmRightStatus === 0">待单录</span>
          <span v-else-if="row.confirmRightStatus === 1">待质检</span>
          <span v-else-if="row.confirmRightStatus === 2">质检成功</span>
          <span v-else-if="row.confirmRightStatus === -1">质检失败</span>
          <Poptip trigger="hover" transfer-class-name="my-poptip left0" :transfer="true">
            <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" v-if="row.confirmRightStatus === -1 && row.qualityFailReason" />
            <div slot="content">
              <p>{{ row.qualityFailReason }}</p>
            </div>
          </Poptip>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click.stop="copyLink(row)" v-if="row.confirmRightStatus === 0 || row.confirmRightStatus === -1">复制确权链接</span>
          <span class="table-btn" @click.stop="$refs.detailModal.open({ ...row, operationFunction: 35 })">详情</span>
        </template>
      </Table>
      <no-data v-else style="margin-top: 250px"></no-data>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
    <!-- 线上保单详情  -->
    <detail-modal ref="detailModal"></detail-modal>
    <!-- 新增质检保单  -->
    <add-form ref="addForm" @success="searchAjax()"></add-form>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import userPoptip from '@/components/commons/userPoptip';
import selectTree from '@/components/system/selectTree3';
import { config } from './qualityTesting.config.js';
import detailModal from '@/pages/orderManage/insuredOrder/components/detailModal';
import addForm from './components/addForm';

export default {
  components: {
    addForm,
    userPoptip,
    detailModal,
    selectTree
  },
  mixins: [pageTool, common, config],
  props: {},
  data() {
    return {
      searchParams: {
        userType: '1',
        confirmRightStatusIn: []
      }
    };
  },
  mounted() {
    this.initListAjax('/buz/policy/read/list');
    if (this.$units.isOkBao() || this.$units.isRYBB()) {
      this.getOkBaoSalesSupport();
    }
  },
  activated() {
    if (this.$route.query.confirmRightStatusIn) {
      this.searchParams.confirmRightStatusIn = this.$route.query.confirmRightStatusIn;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    this.getList();
  },
  methods: {
    // 获取个险、团险销售支持
    getOkBaoSalesSupport() {
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 1
        }
      }).then(res => {
        if (res.data) {
          this.salesSupportList = res.data;
        }
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'order_1_61_0';
    },
    // 转化参数
    setListParams(params) {
      this.getColumns(); //获取表格字段
      params.confirmRightStatusNotNull = 1;
      if (params.date && params.date[0]) {
        params.hesitateTimeStart = this.$units.formatDate(params.date[0]);
        params.hesitateTimeEnd = this.$units.formatDate(params.date[1]);
      }
      delete params.date;
      if (this.$route.query.confirmRightStatusIn) {
        params.confirmRightStatusIn = this.$route.query.confirmRightStatusIn;
      }
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;
      delete params.applyOrgId;
    },
    daochu() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/policy/confirmRightPolicyExport', params, 'POST');
    },
    // 复制确权链接
    copyLink(item) {
      this.$http({
        url: '/buz/policy/queryConfirmRightUrl',
        type: 'GET',
        data: { policyNo: item.policyNo }
      }).then(res => {
        if (res.data) {
          this.$units.copyUrl(res.data);
        } else {
          this.$notice.msg('获取确权链接失败');
        }
      });
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
